import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Snackbar, SnackbarContent } from '@mui/material';
import React, { useEffect } from 'react';
import { createPath } from 'react-router';

import { router } from '@/router.tsx';
import { reloadApp } from '@/utils/appReload.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

import { useVersionCheck } from './util/useVersionCheck';

export const VersionChecker: React.FC = () => {
  const { isNewVersionAvailable } = useVersionCheck();
  const { t } = useTranslationWithPrefix('components.versionChecker');

  useEffect(() => {
    if (!isNewVersionAvailable) {
      return;
    }
    const unsubscribe = router.subscribe(({ location, navigation }) => {
      if (
        navigation.state === 'loading' &&
        !navigation.formMethod &&
        navigation.location.pathname !== location.pathname
      ) {
        unsubscribe();
        void reloadApp(createPath(navigation.location));
      }
    });
    return unsubscribe;
  }, [isNewVersionAvailable]);

  const handleReload = () => {
    void reloadApp();
  };

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      open={isNewVersionAvailable}
    >
      <SnackbarContent
        action={
          <Button color="primary" onClick={handleReload} size="small" startIcon={<RefreshIcon />}>
            {t('refresh')}
          </Button>
        }
        message={t('newVersionAvailable')}
      />
    </Snackbar>
  );
};
